import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FooterIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14.002"}
      height={height || "14"}
      viewBox="0 0 14.002 14"
    >
      <g
        id="Group_10846"
        data-name="Group 10846"
        transform="translate(-16807.002 -16390.191)"
      >
        <path
          id="Path_10372"
          data-name="Path 10372"
          d="M12.5-18.687H1.5A1.584,1.584,0,0,0,0-17.031V-6.343A1.584,1.584,0,0,0,1.5-4.687h11A1.584,1.584,0,0,0,14-6.343V-17.031A1.584,1.584,0,0,0,12.5-18.687Zm0,12.344H1.5V-17.031h11Z"
          transform="translate(16807.002 16408.879)"
          fill="#bbb"
        />
        <g id="Group_10843" data-name="Group 10843">
          <path
            id="Path_10373"
            data-name="Path 10373"
            d="M8.246-11.687H.754A.83.83,0,0,0,0-10.8v1.173a.83.83,0,0,0,.754.888H8.246A.83.83,0,0,0,9-9.626V-10.8A.83.83,0,0,0,8.246-11.687Z"
            transform="translate(16809.504 16409.879)"
            fill={color || "#bbb"}
          />
        </g>
      </g>
    </svg>
  );
}
